export default __webpack_public_path__ + "static/media/primesuperdeals.b5045491.png";